import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import BusinessModuleTypes from '@/store/modules/middleGround/member/business/interface';

const businessModule: Module<BusinessModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        listJoinCategory(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listJoinCategory", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        uploadActivityImg(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/uploadActivityImg", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        getActivity(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/getActivity", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        saveTemporaryInfo(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/saveTemporaryInfo", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        listActivityImage(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/listActivityImage", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        updateActivityStatus(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/updateActivityStatus", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        recallApply(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/recallApply", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
        
    },
};

export default businessModule;